/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectTypesControllerRemoveMutationResponse, ProjectTypesControllerRemovePathParams, ProjectTypesControllerRemove401, ProjectTypesControllerRemove403, ProjectTypesControllerRemove404 } from "../../models/projectTypesController/ProjectTypesControllerRemove";

function getProjectTypesControllerRemoveUrl(id: ProjectTypesControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/project-types/${id}` as const }  
  return res
}

/**
 * @summary Delete a project type
 * {@link /api/v1/project-types/:id}
 */
export async function projectTypesControllerRemove(id: ProjectTypesControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ProjectTypesControllerRemoveMutationResponse, ResponseErrorConfig<ProjectTypesControllerRemove401 | ProjectTypesControllerRemove403 | ProjectTypesControllerRemove404>, unknown>({ method : "DELETE", url : getProjectTypesControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}